module.exports = __webpack_public_path__ + "static/media/apepdcl.9318ba04.jpeg";